import type { LongStayDiscountHint } from '@/shared/schemas/longStayDiscountHint.schema'
import { useLongStayHintLabel } from './useLongStayHintLabel'

type LongStayHintProps = {
  hint: LongStayDiscountHint | null | undefined
  currency: string
  className?: string
}

export function LongStayHint({ hint, currency, className }: LongStayHintProps) {
  const label = useLongStayHintLabel(hint, currency)

  return label === '' ? null : <span className={className}>{label}</span>
}
